export function includesAll(hostArray, subArray) {
  return !subArray.some(function (element) {
    return !hostArray.includes(element);
  });
}